import { defineMessages } from 'react-intl';

export default defineMessages({
	emptyStateDescription: {
		defaultMessage:
			"You haven't created an announcement yet. To create one, select Announcements from the avatar menu.",
		description: 'Empty state message when announcement has not been created',
		id: 'help.center.announcement.edit.empty.state',
	},
	emptyStateAnnouncementDescription: {
		defaultMessage:
			'You haven’t created an announcement yet. Select <b>Customize,</b> then <b>Manage announcements</b> from the navigation to create one. ',
		description: 'Empty state message when announcement has not been created',
		id: 'help.center.announcement.edit.empty.state.announcement',
	},
});
